import React from "react";
import styled from "styled-components";

export default () => (
  <Footer>
    <Wrapper>&#169; Blackbook {`${new Date().getFullYear()}`}</Wrapper>
  </Footer>
);

const Footer = styled.footer`
  margin: 0rem auto;
  background-color: #2f2f33;
`;

const Wrapper = styled.div`
  max-width: 10rem;
  color: #fff;
  height: 10vh;
  margin: 0 auto;
  padding-top: 2rem;
`;
